import {Injectable} from '@angular/core';
import {PictureData} from '../components/picture/picture.component';
import {ScreenType} from '../model/ScreenType';

@Injectable({
  providedIn: 'root'
})
export class MediaPictureService {

  private regExp = new RegExp('^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$');

  constructor() {
  }

  getMediaKey(mediaUrl?: string) {
    return mediaUrl?.split('/').find(path => this.regExp.test(path));
  }

  getMediaUrl(mediaKey?: string, size?: string) {
    size = this.getImageSize(mediaKey, size);
    const url = this.getMediaKey(mediaKey) && `//media.staticontent.com/media/pictures/${this.getMediaKey(mediaKey)}` || mediaKey;
    return size && !url?.includes('size=') ? url + '/' + size : url;
  }

  isSizeValid(size: string): boolean {
    const split = size.split('x');
    const width = parseInt(split[0]);
    const height = parseInt(split[1]);

    return width > 0 && height > 0;
  }

  getImageSize(mediaKey?: string, defaultSize?: string): string | undefined {
    // En caso de que image ya contenga un tamaño lo retorno, sino retorno el tamaño por defecto
    if (mediaKey) {
      const split = mediaKey.split('/');
      const last = split[split.length - 1];
      if (last.includes('x') && this.isSizeValid(last)) {
        return last;
      }
    }
    
    return defaultSize || undefined;
  }

  getMediaUrlByPictureData(pictureData: PictureData, screenType: ScreenType) {
    let size = pictureData.height && pictureData.width ? `${pictureData.width}x${pictureData.height}` : undefined;
    if (screenType === ScreenType.MOBILE && pictureData?.src_mobile) {
      return this.getMediaUrl(pictureData.src_mobile, size);
    } else {
      return this.getMediaUrl(pictureData?.src, size);
    }
  }

  getMediaKeyByPictureData(pictureData: PictureData, screenType: ScreenType) {
    if (screenType === ScreenType.MOBILE && pictureData?.src_mobile) {
      return this.getMediaKey(pictureData.src_mobile);
    } else {
      return this.getMediaKey(pictureData?.src);
    }
  }

  getAltByPictureData(pictureData: PictureData | undefined, screenType: ScreenType) {
    if (screenType === ScreenType.MOBILE && pictureData?.alt_mobile) {
      return pictureData.alt_mobile;
    } else {
      return pictureData?.alt;
    }
  }

  getSrcset(mediaKey: string, size: string): string {
    const baseUrl = `//media.staticontent.com/media/pictures/${this.getMediaKey(mediaKey)}/${size}`;
    const params = '?op=TRUNCATE&enlarge=false&gravity=ce_0_0&quality=80&dpr=';
    const dprs = [1, 1.5, 2, 2.5, 3, 3.5];

    return dprs.map(dpr => `${baseUrl}${params}${dpr} ${dpr}x`).join(', ');
  }
}
